import React, { Component } from 'react';
import "./vodafone.css"
import {I18nextProvider} from "react-i18next";
import i18n from "./i18n";
import MainPage from "./pages/MainPage";
import {isMobile} from "react-device-detect";

class App extends Component {

    render() {
        return (
            <I18nextProvider i18n={i18n}>
                <div className="global-font">
                    <MainPage/>
                </div>
            </I18nextProvider>
        );
    }
}

export default App;
